import { localize } from '../../i18n';
import SingleLineText from '../ui/SingleLineText';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { getLevelTheme } from './stages';

/**
 * XP 진행 바.
 * - size: 'mini' (헤더) | 'large' (통계 카드)
 * - progress: 0~1
 * - level: 컬러 매핑용
 * - currentXp, totalXp: 바 안에 "N/M" 형식으로 노출 (메이플 스타일). large에만 적용
 * - label: 'large'에서 아래에 표시되는 보조 텍스트
 */
export default function XpGauge({
    progress = 0,
    level = 0,
    size = 'mini',
    label,
    currentXp,
    totalXp,
}) {
    const theme = getLevelTheme(level);
    const clamped = Math.max(0, Math.min(1, progress));
    const isMini = size === 'mini';
    const hasXpText = typeof currentXp === 'number' && typeof totalXp === 'number';
    // 텍스트가 있으면 트랙을 키워서 안에 들어가도록
    const trackHeight = isMini ? (hasXpText ? 14 : 4) : 16;

    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: trackHeight,
                    borderRadius: trackHeight,
                    backgroundColor: '#EDEDED',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        width: `${clamped * 100}%`,
                        height: '100%',
                        borderRadius: trackHeight,
                        background: `linear-gradient(90deg, ${theme.gauge}, ${theme.accent})`,
                        transition: 'width 350ms ease-out',
                    }}
                />
                {hasXpText && (
                    <Typography
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: isMini ? '0.6rem' : '0.78rem',
                            fontWeight: 700,
                            color: '#1a1a1a',
                            letterSpacing: '-0.02em',
                            textShadow: '0 0 2px rgba(255,255,255,0.7)',
                            lineHeight: 1,
                            pointerEvents: 'none',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {currentXp} / {totalXp}{localize("점")}</Typography>
                )}
            </Box>
            {!isMini && label && (
                <SingleLineText sx={{ fontSize: '0.85rem', color: '#888', mt: 0.6 }}>
                    {label}
                </SingleLineText>
            )}
        </Box>
    );
}
